import React, { useState } from 'react'

import {
  Icon, TextInput, VisibilityOff, VisibilityOn,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

function PasswordField({ value, locale = 'en', onChange }) {
  const [showPassword, setShowPassword] = useState(false)
  const t = key => i18n.t(`auth_modal.password.${key}`, { ns: 'rails', lng: locale })

  const handleToggleVisibility = () => {
    setShowPassword(current => !current)
  }

  return (
    <TextInput
      id="sign-in-password"
      name="password"
      inputType={showPassword ? 'text' : 'password'}
      size="medium"
      label={t('password_label')}
      value={value}
      onChange={onChange}
      wrapperClassName="auth-modal__field"
      autoComplete="current-password"
      isPilot
      trailIcon={(
        <Icon
          svgComponent={showPassword ? VisibilityOff : VisibilityOn}
          color="dark"
          withHover
          onClick={handleToggleVisibility}
          aria-label={t(showPassword ? 'hide_password' : 'show_password')}
        />
      )}
    />
  )
}

PasswordField.propTypes = {
  value: string.isRequired,
  locale: string,
  onChange: func.isRequired,
}

export default PasswordField
